<template>
  <fieldset class="filter-item elem" >
    <legend class="filter-item_header">
      <button class="fieldsetOpenHide"
              @click="onClickFieldset"
              :aria-expanded="isShowFildset ? 'true' : 'false'"
              :aria-controls="`panel-${dataFilterForm.solr_filter}`" >
                {{ dataFilterForm.title }}  <i class="icon-up" aria-hidden="true"></i>
      </button>
    </legend>
    <transition name="slide">
      <div class="filter-item_content visible"  v-if="isShowFildset" :id="`panel-${dataFilterForm.solr_filter}`">
        <div class="description" v-if="dataFilterForm.text" v-html="$sanitize(dataFilterForm.text)" ></div>
        <div class="listItemsFildset">
          <div class="input input-type-checkbox" v-for="(formFilterValuesElem, formFilterValuesIndex) in dataFilterForm.values"
               :key="`${formFilterValuesElem.solr_filter}-${formFilterValuesElem.id}`" :class="{'hideElem': formFilterValuesIndex > limitInputs - 1,'showElem': showMoreElements}">
            <input
              type="checkbox"
              :value="`id-${formFilterValuesElem.id}`"
              :checked="isChecked(formFilterValuesElem.solr_filter, formFilterValuesElem.id)"
              :id="`${formFilterValuesElem.solr_filter}-${formFilterValuesElem.id}`"
              @change="$emit('changeFilters',[formFilterValuesElem.solr_filter,formFilterValuesElem.id])">
            <label :for="`${formFilterValuesElem.solr_filter}-${formFilterValuesElem.id}`">
              {{formFilterValuesElem.label }}</label>
          </div>
          <a href="#?" v-if="dataFilterForm.values.length > limitInputs" class="showMore" @click="showMore">
            <span v-if="showMoreElements">{{ThematicCardTranslate.popin.show_moins_text}}</span>
            <span v-else>{{ThematicCardTranslate.popin.show_plus_text}}</span>
          </a>
        </div>
      </div>
    </transition>
  </fieldset>
</template>
<script>
import { ref, inject } from 'vue';
import { ThematicCardTranslate } from '@/services/translate';

export default {
  props: {
    dataFilterForm: {
      type: Object,
      default: () => ({}),
    },
  },
  setup() {
    const isShowFildset = ref(true);
    const showMoreElements = ref(false);
    const limitInputs = ref(5);
    const listCurrentFilter = inject('listCurrentFilter', {});

    function onClickFieldset() {
      isShowFildset.value = !isShowFildset.value;
    }
    function showMore() {
      showMoreElements.value = !showMoreElements.value;
    }

    function isChecked(solrId, elemId) {
      let checkedStatus = false;
      Object.keys(listCurrentFilter.value).forEach((filterKey) => {
        if (filterKey === solrId && listCurrentFilter.value[filterKey].includes(elemId)) {
          checkedStatus = true;
        }
      });

      return checkedStatus;
    }

    function checkedFilter(id, solrId) {
      const listChecked = listCurrentFilter;
      return listChecked[solrId] ? listChecked[solrId].includes(id) : false;
    }

    return {
      isShowFildset,
      limitInputs,
      isChecked,
      ThematicCardTranslate,
      showMoreElements,
      showMore,
      onClickFieldset,
      checkedFilter,
      listCurrentFilter,
    };
  },
};
</script>
